module.exports = __webpack_public_path__ + "static/img/anger4.0e9e08ce.png";